const SUBSCRIPTION_PLANS = {
    Basic: { features: ['INVOICES', 'INVENTORY'] },
    Standard: { features: ['INVOICES', 'INVENTORY', 'SUPPLIERS', 'CUSTOMERS', 'EXPENSES', 'REPORTS', 'ACCOUNTING'] },
    Premium: { features: ['ALL'] },
};

export const hasSubscriptionFeature = (planName, featureName) => {
    if (!planName || !featureName) return true;
    const plan = SUBSCRIPTION_PLANS[planName] || SUBSCRIPTION_PLANS.Basic;
    if (plan.features.includes('ALL')) return true;
    return plan.features.includes(featureName);
};
